import type { UserSession } from '@/types/session';

export const INSTALLATION_PERMISSIONS = {
  iq: 'operations.installations.iq',
} as const;

type InstallationPermissionUser = Pick<UserSession, 'permission_strings' | 'postgres_roles'>;

export function canReviewInstallationIq(
  user: InstallationPermissionUser | null | undefined,
): boolean {
  const roles = user?.postgres_roles ?? [];

  return roles.includes('full_admin')
    || (user?.permission_strings?.includes(INSTALLATION_PERMISSIONS.iq) ?? false);
}
